import { render, staticRenderFns } from "./vipPopFrame.vue?vue&type=template&id=583e3c69&scoped=true"
import script from "./vipPopFrame.vue?vue&type=script&lang=js"
export * from "./vipPopFrame.vue?vue&type=script&lang=js"
import style0 from "./vipPopFrame.vue?vue&type=style&index=0&id=583e3c69&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583e3c69",
  null
  
)

export default component.exports